import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3338/notification";
};

export const getNotificationCount = () => {
  const url = `${baseURL()}/count`;

  return axios.get(url);
};

export const loadNotificationList = params => {
  const url = `${baseURL()}/load`;

  return axios.post(url, params);
};

export const deleteNotification = (id, params) => {
  const url = `${baseURL()}/delete${id !== null ? "/" + id : ""}`;

  return axios.post(url, params);
};

export const markNotificationAsRead = (id, params) => {
  const url = `${baseURL()}/read${id !== null ? "/" + id : ""}`;

  return axios.post(url, params);
};
